import * as React from 'react'
import { useFormat } from '@/src/infrastructure/lib/format'
import type { TopEventRow } from '../types'

interface Props {
  rows: TopEventRow[]
}

export function TopEventsTable({ rows }: Props) {
  const fmt = useFormat()

  if (rows.length === 0) {
    return (
      <p className="text-sm text-on-surface-variant py-8 text-center">
        No events yet. Once you publish invitations, your top performers will appear here.
      </p>
    )
  }

  return (
    <div className="overflow-x-auto -mx-1">
      <table className="w-full text-sm">
        <thead>
          <tr className="text-left text-xs uppercase tracking-wide text-on-surface-variant">
            <th className="font-medium px-2 py-2">Event</th>
            <th className="font-medium px-2 py-2 hidden md:table-cell">Date</th>
            <th className="font-medium px-2 py-2 text-right">Views</th>
            <th className="font-medium px-2 py-2 text-right">RSVPs</th>
            <th className="font-medium px-2 py-2 text-right hidden sm:table-cell">Conv.</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr
              key={row.id}
              className="border-t border-outline-variant/20 hover:bg-surface-low/50 transition-colors"
            >
              <td className="px-2 py-3">
                <div className="font-semibold text-on-surface line-clamp-1">{row.eventName}</div>
                <div className="text-xs text-on-surface-variant">
                  {prettyOccasion(row.occasionType)} · {prettyStatus(row.status)}
                </div>
              </td>
              <td className="px-2 py-3 text-on-surface-variant hidden md:table-cell">
                {fmt.date(row.eventDate)}
              </td>
              <td className="px-2 py-3 text-right text-on-surface tabular-nums">
                {row.totalViews.toLocaleString()}
              </td>
              <td className="px-2 py-3 text-right text-on-surface tabular-nums">
                {row.totalRsvps.toLocaleString()}
              </td>
              <td className="px-2 py-3 text-right text-on-surface tabular-nums hidden sm:table-cell">
                {row.conversionRate}%
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

function prettyOccasion(occasion: string): string {
  return occasion
    .toLowerCase()
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase())
}

function prettyStatus(status: string): string {
  return status.charAt(0) + status.slice(1).toLowerCase()
}
